module.exports = __webpack_public_path__ + "img/tjjj.096ab6a0.png";